export enum EOfferSpendByOfferScopeView {
	Day = 'day',
	Month = 'month',
}

export const OFFER_SPEND_BY_OFFER_SCOPE_VIEW_LABEL_MAP: Record<EOfferSpendByOfferScopeView, string> = {
	[EOfferSpendByOfferScopeView.Day]: `offer_spend_by_offer_scope_view.${EOfferSpendByOfferScopeView.Day}`,
	[EOfferSpendByOfferScopeView.Month]: `offer_spend_by_offer_scope_view.${EOfferSpendByOfferScopeView.Month}`
}